import React from 'react';
import { EditableInfo } from '@icoach/components';
import { Icons, Stack, Typography } from "@curves/ui-base";

const MeasureDayBox = ({ className, sourceData, onEdit }) => {
    const { isFinishSevenDay, isMonthMeasured, measureDay } = sourceData;
    return (
        <EditableInfo label="WM日" onEdit={onEdit} className={className} isEdit>
            <Stack alignItems="center" justifyContent="center" spacing={2}>
                {isFinishSevenDay ? <Icons.Check color="success" /> : <Typography component="span">{measureDay || '未設定'}</Typography>}
                {isMonthMeasured ? <Icons.Measuring fontSize="large" color="primary" /> : null}
            </Stack>
        </EditableInfo>
    );
};

export default MeasureDayBox;
